import { keyframes, styled } from '@ori-ui/mui';
import { shouldForwardProp } from '@ori/presentation-utils';
import { getDotMargin, getDotSize, getRectangleWidth } from '../utils';
const loading = keyframes`
  100% {
    background-position: left;
  }
`;
export const PaginationRoot = styled('div')({
  alignItems: 'center',
  bottom: '15px',
  display: 'flex',
  justifyContent: 'center',
  left: '0',
  position: 'absolute',
  textAlign: 'center',
  width: '100%',
  zIndex: 3
});
export const PaginationStepRoot = styled('span', {
  shouldForwardProp: shouldForwardProp()
})(({
  autoplay,
  hidden,
  isActive,
  isNext,
  isPrevious,
  pagination,
  theme
}) => {
  const style = {
    background: isActive ? theme.palette.blueGrey['300'] : theme.palette.grey.A200,
    borderRadius: '50%',
    cursor: isActive ? 'default' : 'pointer',
    display: hidden ? 'none' : 'inline-block',
    height: getDotSize({
      isActive,
      isNext,
      isPrevious
    }),
    margin: theme.spacing(getDotMargin({
      isActive,
      isNext,
      isPrevious
    }), 1),
    opacity: '1',
    transition: 'margin 300ms, background 300ms, width 300ms, height 300ms',
    verticalAlign: 'middle',
    width: getDotSize({
      isActive,
      isNext,
      isPrevious
    }),
    '&:hover': {
      animation: 'none'
    }
  };
  if (pagination?.style === 'rectangles') {
    style.background = isActive ? theme.palette.common.white : 'rgba(255, 255, 255, 0.1)';
    style.backdropFilter = 'blur(20px) brightness(106%)';
    style.borderRadius = '900px';
    style.height = '6px';
    style.width = getRectangleWidth({
      isNext,
      isPrevious
    });
  }
  if (autoplay?.enabled && isActive) {
    style.animation = `${loading} ${autoplay.interval ?? 0}ms 0s forwards linear`;
    style.backgroundSize = '200% 100%';
    style.backgroundPosition = 'right';
    style.transition = 'width 300ms, height 300ms';
    if (pagination?.style === 'dots') {
      style.background = `linear-gradient(to right, ${theme.palette.blueGrey['300']} 50%, ${theme.palette.grey.A200} 0)`;
      style.borderRadius = '5px';
      style.height = getDotSize();
      style.width = '20px';
    }
    if (pagination?.style === 'rectangles') {
      style.background = `linear-gradient(to right, ${theme.palette.common.white} 50%, rgba(255, 255, 255, 0.1) 0)`;
    }
  }
  return style;
});
//# sourceMappingURL=pagination.js.map